import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import { Loader } from '../Loader';
import { DefaultButton, DefaultDestructiveButton, PrimaryButton, PrimaryDestructiveButton, FlatButton, LinkButton, UnstyledButton, LoadingWrapper, MainContent, } from './components/styled';
import { DropdownIcon } from '../../tempIcons/DropdownIcon';
const variantMap = {
    default: DefaultButton,
    primary: PrimaryButton,
    destructive: DefaultDestructiveButton,
    primaryDestructive: PrimaryDestructiveButton,
    flat: FlatButton,
    link: LinkButton,
    unstyled: UnstyledButton,
};
export const Button = forwardRef((_a, ref) => {
    var { className, children, icon, variant = 'default', size = 'base', dropdown = false, loading = false } = _a, otherProps = __rest(_a, ["className", "children", "icon", "variant", "size", "dropdown", "loading"]);
    if (variant === 'unstyled') {
        return (React.createElement(UnstyledButton, Object.assign({ ref: ref, className: className }, otherProps), children));
    }
    const VariantButton = variantMap[variant];
    const hasChildren = children !== undefined;
    const hasIcon = !!icon;
    return (React.createElement(VariantButton, Object.assign({ ref: ref, className: className, size: size, hasText: hasChildren, hasIcon: hasIcon, hasDropdown: dropdown }, otherProps),
        (hasChildren || hasIcon) && (React.createElement(MainContent, { loading: loading, hasText: !!children, size: children || size === 'sm' ? 'base' : 'md' },
            icon && icon,
            children !== undefined && React.createElement("span", null, children),
            dropdown && React.createElement(DropdownIcon, null))),
        loading && (React.createElement(LoadingWrapper, null,
            React.createElement(Loader, null)))));
});
//# sourceMappingURL=Button.js.map